import { CSSProperties, useEffect } from 'react';
import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { actions } from 'store';
import { Link } from 'components/common';

import type { PageState } from 'types';

interface Props {
  codeFontSize?: string;
  course: PageState['course'] | PageState['readerCourseData']['course'];
  infoFontSize?: string;
  isReader?: boolean;
  style?: CSSProperties;
}

const CourseShareCode = ({
  codeFontSize,
  course,
  infoFontSize,
  isReader,
  style
}: Props) => {
  const { dispatch } = useDispatch();

  const { messages, pageState, serverConfig } = useReduxState();

  const generateShareCode = async () => {
    try {
      const response = await api.post(`/admin/courses/${course.id}/share-code`);
      if (response.data.success && response.data.shareCode) {
        const newPageState = isReader
          ? {
              readerCourseData: {
                ...pageState.readerCourseData,
                course: { ...course, shareCode: response.data.shareCode }
              }
            }
          : { course: { ...course, shareCode: response.data.shareCode } };
        dispatch(actions.updatePageState(newPageState as PageState));
      } else throw new Error('error');
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  useEffect(() => {
    if (course && !course.shareCode) generateShareCode();
  }, []);

  return (
    <div className="share-code" style={style}>
      <div className="code">{course.shareCode}</div>

      <div className="info">{messages.coursesShareCodeInfo}</div>

      <div className="link">
        <Link
          href={`${serverConfig.adminUrl}/code`}
          text={`${serverConfig.adminUrl.replace(/https?:\/\//, '')}/code`}
        />
      </div>

      <style jsx>{`
        .code {
          font-size: ${codeFontSize || '3.6rem'};
          font-weight: 700;
          letter-spacing: 5px;
        }
        .info {
          display: inline-block;
          font-size: ${infoFontSize || '1.6rem'};
          font-weight: 600;
          line-height: 1.5;
          max-width: 360px;
          margin-top: 5px;
        }
        .link {
          font-size: ${infoFontSize || '1.6rem'};
          margin-top: 10px;
        }
      `}</style>
    </div>
  );
};

export default CourseShareCode;
